module.exports = __webpack_public_path__ + "assets/img/ru-5b7e9976.png";